/** The page's service worker container; `undefined` where workers are not supported. */
export function getServiceWorkerContainer(): ServiceWorkerContainer | undefined {
  return typeof navigator !== 'undefined' && 'serviceWorker' in navigator ? navigator.serviceWorker : undefined;
}
